import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ComponentTheme } from '@helpers/themeEnum';
import { contentStyles } from '@helpers/typography';
import SvgChevronDown from '@img/icons/select-arrow.svg?url';
import FieldRowStyles from '@stories/Components/ZohoForms/Components/FieldRow/FieldRow.styles';
import styled from 'styled-components';
import { inputStyles } from '../Components/Input/Input.styles';
import RecaptchaStyles from '../Components/Recaptcha/Recaptcha.styles';
const Form = styled.form `
  --accentColour: ${brand.blue.base};

  [data-page-theme=${ComponentTheme.Green}] & {
    --accentColour: ${brand.green.base};
  }

  [data-page-theme=${ComponentTheme.Yellow}] & {
    --accentColour: ${brand.yellow.base};
  }

  [data-page-theme=${ComponentTheme.Orange}] & {
    --accentColour: ${brand.orange.base};
  }

  [data-theme=${ComponentTheme.Green}] & {
    --accentColour: ${brand.green.base};
  }

  [data-theme=${ComponentTheme.Yellow}] & {
    --accentColour: ${brand.yellow.base};
  }

  [data-theme=${ComponentTheme.Orange}] & {
    --accentColour: ${brand.orange.base};
  }

  hr {
    width: 100%;
    height: 2px;
    background-color: ${brand.white};
    border: none;
    margin: 30px 0;
    padding: 0;
  }

  .PhoneInputInput {
    ${inputStyles};
  }

  ${FieldRowStyles.Container}:has(${RecaptchaStyles.RecaptchaWrapper}) {
    margin: ${fluid(6, 36)} 0 ${fluid(46, 64)};
  }

  &[data-slimline='true'] {
    max-width: 832px;
    margin: 0 auto;
  }
`;
const SelectWrapper = styled.div `
  position: relative;

  .PhoneInputCountryIcon {
    display: flex;
    place-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding: 6px;
    pointer-events: none;
  }

  span {
    display: block;
    width: 100%;
    ${fonts.montserrat.medium}
    font-size: 20px;
    padding: 0 26px 0 6px;
    text-align: center;
    color: ${brand.grey.grey16};
    background-color: ${brand.white};
    background-image: url(${SvgChevronDown});
    background-repeat: no-repeat;
    background-position: center right 6px;
    background-size: 24px 14px;
  }
`;
const Error = styled.div `
  ${fonts.montserrat.mediumItalic};

  color: ${brand.validation.red};
  margin: 4px 0 0;
`;
const Disclaimer = styled.div `
  ${contentStyles};

  p,
  a {
    font-size: ${fluid(14, 16)};
  }
  margin-bottom: ${fluid(0, 16)};
`;
const ZohoFormStyles = {
    Form,
    SelectWrapper,
    Error,
    Disclaimer,
};
export default ZohoFormStyles;
